module.exports = __webpack_public_path__ + "static/media/40.e7f8633b.jpeg";